﻿import React, {ChangeEvent, JSX, useCallback} from "react";
import {useControlId} from "../helpers/useControlId";
import Switch from "../HtmlControls/Switch";
import {MvvmContextState} from "./MvvmContextState";
import {MvvmControlProps} from "./MvvmControlProps";

import {useRegisterValidation} from "./useRegisterValidation";

export type MvvmSwitchProps<T extends object = never> = Omit<MvvmControlProps<T, boolean>, "hint">;

export default function MvvmSwitch<T extends object = never>(props: MvvmSwitchProps<T>): JSX.Element {
	const {
		context,
		property,
		id,
		label,
		column,
		hidden,
		disabled,
		validation
	} = props;

	const controlId = useControlId(id);

	const checked = context.getValue<boolean>(property) ?? false;

	const onChange = useCallback(function (e: ChangeEvent<HTMLInputElement>): void {
		(context as MvvmContextState<T>).setValue(property, e.target.checked);
	}, [context, property, validation, controlId]);

	useRegisterValidation(context, property, controlId, validation);

	return <Switch id={id}
	               label={label}
	               name={controlId}
	               column={column}
	               onChange={onChange}
	               hidden={hidden}
	               disabled={disabled}
	               checked={checked}/>;
};
